module.exports = __webpack_public_path__ + "static/media/ic-caret-down-fill.5be72da7.svg";